export default __webpack_public_path__ + "static/FletcherJones-9484021c9c437809a6263bb07db9c1a0.svg";